import { LanguageName } from "@axon-enterprise/i18n";

import { SUPPORTED_LANGUAGES } from "./constants";

interface UseLanguageLoaderOptions {
  supportedLanguages?: LanguageName[];
  fallbackLanguage?: LanguageName;
}

const useLanguageLoader = (options: UseLanguageLoaderOptions = {}) => {
  const {
    supportedLanguages = SUPPORTED_LANGUAGES,
    fallbackLanguage = LanguageName.English_US,
  } = options;

  const loadLanguage = async (language: string): Promise<Record<string, string>> => {
    const targetLanguage = supportedLanguages.includes(language as LanguageName) ? language as LanguageName : fallbackLanguage;
    
    try {
      const module = await import(`./locales/${targetLanguage}.json`);
      return module.default;
    } catch {
      // Fallback if requested language file doesn't exist
      const fallbackModule = await import(`./locales/${fallbackLanguage}.json`);
      return fallbackModule.default;
    }
  };

  return loadLanguage;
};

export default useLanguageLoader;

